export default __webpack_public_path__ + "static/media/3662.b107d433.png";